import React, { useState, useEffect } from 'react'
import styled from 'styled-components'

import {
    Row, 
    Col, 
    Form,
    message,
} from 'antd'

import Cloudinary from '../../utils/Space.Service.Cloudinary'

import Modal from '../../components/Modal'

import Header from '../post/Header'
import Loader from '../post/Loader'

import Footer from './Footer'

import Text from '../../components/Field.Text'
import Action from './Field.Action'

const Container = styled.div`
    border-top: 1px solid #e8e8e8;

    min-height: 200px;
    padding: 32px 16px;

    @media (min-width: 768px)
    {
        padding: 32px;
    }
`

function Comp (
    {
        match,
        history,
    }
)
{
    const { id } = match.params

    const [ action, setAction ] = useState(null)
    
    const [ original, setOriginal ] = useState({ })
    const [ current,  setCurrent ] = useState({ })

    const invalid = !action && Cloudinary.Document.getInvalidFields(current).length > 0
    const changed = !action && Cloudinary.Document.getChangeds(original, current).length > 0

    const canSave = !!changed && !action && !invalid
    const disabled = !!action || current.status === 'active'

    function handleMount ()
    {
        setOriginal({ })
        setCurrent({ })

        setAction(id !== 'create' ? 'loading' : null)

        const unsubscribes = []
        const promises = []

        if (id !== 'create')
        {
            promises.push(
                Cloudinary.Query.get (id, function ({ original, current })
                {
                    if (!!original)
                    {
                        setOriginal (original)
                    }

                    if (!!current)
                    {
                        setCurrent (current)
                        setAction (null)
                    }
                })
            )
        }

        Promise.all(promises).then(function (us)
        {
            us.forEach(function (u)
            {
                unsubscribes.push(u)
            })
        })

        return function ()
        {
            unsubscribes.filter(u => !!u).forEach(u => u())
        }
    }

    function handleClose ()
    {
        history.replace (`/cloudinary`)
    }

    function handleChange (name, value)
    {
        setCurrent ({ ...current, [name]: value })
    }

    async function handleSave ()
    {
        setAction('saving')

        try
        {
            const result = await Cloudinary.Update.save (current)

            if (result.error)
            {
                setAction(null)
                // setValidations(result.error.validations || { })

                message.error('พบข้อผิดพลาดระหว่างการบันทึก กรุณาตรวจสอบข้อมูลและบันทึกอีกครั้ง')
            }
            else
            {
                setAction(null)
                // setValidations({ })
                // setTemps([ ])

                if (result.action === 'create')
                {
                    history.replace (`/cloudinary/${result.id}`)
                }

                message.success('บันทึก Cloudinary Setting เรียบร้อย')
            }
        }
        catch (err)
        {
            setAction(null)
            message.error('พบข้อผิดพลาดระหว่างการบันทึก กรุณาตรวจสอบข้อมูลและบันทึกอีกครั้ง')
        }
    }
    
    async function handleActivate ()
    {
        setAction('activating')

        try
        {
            await Cloudinary.Update.activate (current)

            setAction(null)

            message.success('Activate เรียบร้อยแล้ว')
        }
        catch (err)
        {
            setAction(null)
            message.error('พบข้อผิดพลาดระหว่างการ Activate กรุณาตรวจสอบข้อมูลและ Activate อีกครั้ง')
        }
    }

    async function handleDelete ()
    {
        setAction('deleting')

        try
        {
            await Cloudinary.Update.delete (current)

            setAction(null)

            message.success('ลบเรียบร้อยแล้ว')
            
            handleClose ()
        }
        catch (err)
        {
            setAction(null)
            message.error('พบข้อผิดพลาดระหว่างการลบ กรุณาลองใหม่อีกครั้ง')
        }
    }

    useEffect (handleMount, [ id ])

    let ready = action !== 'loading'
    let formLayout = { colon: false }

    let name = current.name || ''
    let key = current.key || ''
    let secret = current.secret || ''

    return (
        <Modal
            open={true}

            header={
                <Header
                    title={id !== 'create' ? 'แก้ไข Cloudinary Setting' : 'สร้าง Cloudinary Setting'}
                    disabled={!!action}
                    changed={changed}
                    onClose={
                        function ()
                        {
                            if (!!handleClose)
                            {
                                handleClose ()
                            }
                        }
                    }
                />
            }

            footer={
                <Footer
                    updatedAt={current.updatedAt}
                    status={current.status}

                    action={action}
                    canSave={canSave}
                    onSave={handleSave}
                />
            }

            style={
                {
                    backgroundColor: `#fdfdfd`,
                }
            }
        >
            {
                !!ready &&
                <Container>
                    <Form layout="vertical" >
                        <Row gutter={32} >
                            <Col 
                                xs={24}
                                sm={24} 
                                md={16}
                                lg={18}
                            >
                                <Text 
                                    layout={formLayout}
                                    label="Cloud Name"
                                    name="name"
                                    value={name}
                                    limit={120}
                                    disabled={!!disabled}
                                    onChange={handleChange}
                                />

                                <Text 
                                    layout={formLayout}
                                    label="API Key"
                                    name="key"
                                    value={key}
                                    limit={120}
                                    disabled={!!disabled}
                                    onChange={handleChange}
                                />

                                <Text 
                                    layout={formLayout}
                                    label="API Secret Key"
                                    name="secret"
                                    value={secret}
                                    limit={120}
                                    disabled={!!disabled}
                                    onChange={handleChange}
                                />
                            </Col>
                            <Col 
                                xs={24} 
                                sm={12}
                                md={8}
                                lg={6}
                            >
                                <Row gutter={8} >
                                    <Col 
                                        xs={24}
                                    >
                                        <Action 
                                            action={action}
                                            status={current.status}
                                            onActivate={handleActivate}
                                            onDelete={handleDelete}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Form>
                </Container>
            }
            {!ready && <Loader />}
        </Modal>
    )
}

export default Comp